/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.28.2
// source: internal/proto/goveeenergymonitoring.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.proto = require('./goveeenergymonitoring_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.GoveeEnergyMonitoringBackendClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.GoveeEnergyMonitoringBackendPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.RegisterSmartPlugRequest,
 *   !proto.proto.SmartPlug>}
 */
const methodDescriptor_GoveeEnergyMonitoringBackend_RegisterSmartPlug = new grpc.web.MethodDescriptor(
  '/proto.GoveeEnergyMonitoringBackend/RegisterSmartPlug',
  grpc.web.MethodType.UNARY,
  proto.proto.RegisterSmartPlugRequest,
  proto.proto.SmartPlug,
  /**
   * @param {!proto.proto.RegisterSmartPlugRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.SmartPlug.deserializeBinary
);


/**
 * @param {!proto.proto.RegisterSmartPlugRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.SmartPlug)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.SmartPlug>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.GoveeEnergyMonitoringBackendClient.prototype.registerSmartPlug =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringBackend/RegisterSmartPlug',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringBackend_RegisterSmartPlug,
      callback);
};


/**
 * @param {!proto.proto.RegisterSmartPlugRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.SmartPlug>}
 *     Promise that resolves to the response
 */
proto.proto.GoveeEnergyMonitoringBackendPromiseClient.prototype.registerSmartPlug =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringBackend/RegisterSmartPlug',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringBackend_RegisterSmartPlug);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.GoveeEnergyMonitoringUIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.GoveeEnergyMonitoringUIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListSmartPlugsRequest,
 *   !proto.proto.ListSmartPlugsResponse>}
 */
const methodDescriptor_GoveeEnergyMonitoringUI_ListSmartPlugs = new grpc.web.MethodDescriptor(
  '/proto.GoveeEnergyMonitoringUI/ListSmartPlugs',
  grpc.web.MethodType.UNARY,
  proto.proto.ListSmartPlugsRequest,
  proto.proto.ListSmartPlugsResponse,
  /**
   * @param {!proto.proto.ListSmartPlugsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListSmartPlugsResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListSmartPlugsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListSmartPlugsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListSmartPlugsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.GoveeEnergyMonitoringUIClient.prototype.listSmartPlugs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/ListSmartPlugs',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_ListSmartPlugs,
      callback);
};


/**
 * @param {!proto.proto.ListSmartPlugsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListSmartPlugsResponse>}
 *     Promise that resolves to the response
 */
proto.proto.GoveeEnergyMonitoringUIPromiseClient.prototype.listSmartPlugs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/ListSmartPlugs',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_ListSmartPlugs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TimeSeriesRequest,
 *   !proto.proto.TimeSeriesResponse>}
 */
const methodDescriptor_GoveeEnergyMonitoringUI_GetSamplesWithMetadata = new grpc.web.MethodDescriptor(
  '/proto.GoveeEnergyMonitoringUI/GetSamplesWithMetadata',
  grpc.web.MethodType.UNARY,
  proto.proto.TimeSeriesRequest,
  proto.proto.TimeSeriesResponse,
  /**
   * @param {!proto.proto.TimeSeriesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.TimeSeriesResponse.deserializeBinary
);


/**
 * @param {!proto.proto.TimeSeriesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.TimeSeriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.TimeSeriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.GoveeEnergyMonitoringUIClient.prototype.getSamplesWithMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/GetSamplesWithMetadata',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_GetSamplesWithMetadata,
      callback);
};


/**
 * @param {!proto.proto.TimeSeriesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.TimeSeriesResponse>}
 *     Promise that resolves to the response
 */
proto.proto.GoveeEnergyMonitoringUIPromiseClient.prototype.getSamplesWithMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/GetSamplesWithMetadata',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_GetSamplesWithMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.TimeSeriesRequest,
 *   !proto.proto.TimeSeriesResponse>}
 */
const methodDescriptor_GoveeEnergyMonitoringUI_GetAggregatedSamplesWithMetadata = new grpc.web.MethodDescriptor(
  '/proto.GoveeEnergyMonitoringUI/GetAggregatedSamplesWithMetadata',
  grpc.web.MethodType.UNARY,
  proto.proto.TimeSeriesRequest,
  proto.proto.TimeSeriesResponse,
  /**
   * @param {!proto.proto.TimeSeriesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.TimeSeriesResponse.deserializeBinary
);


/**
 * @param {!proto.proto.TimeSeriesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.TimeSeriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.TimeSeriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.GoveeEnergyMonitoringUIClient.prototype.getAggregatedSamplesWithMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/GetAggregatedSamplesWithMetadata',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_GetAggregatedSamplesWithMetadata,
      callback);
};


/**
 * @param {!proto.proto.TimeSeriesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.TimeSeriesResponse>}
 *     Promise that resolves to the response
 */
proto.proto.GoveeEnergyMonitoringUIPromiseClient.prototype.getAggregatedSamplesWithMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/GetAggregatedSamplesWithMetadata',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_GetAggregatedSamplesWithMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.SummaryStatisticsRequest,
 *   !proto.proto.SummaryStatisticsResponse>}
 */
const methodDescriptor_GoveeEnergyMonitoringUI_GetSummaryStatistics = new grpc.web.MethodDescriptor(
  '/proto.GoveeEnergyMonitoringUI/GetSummaryStatistics',
  grpc.web.MethodType.UNARY,
  proto.proto.SummaryStatisticsRequest,
  proto.proto.SummaryStatisticsResponse,
  /**
   * @param {!proto.proto.SummaryStatisticsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.SummaryStatisticsResponse.deserializeBinary
);


/**
 * @param {!proto.proto.SummaryStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.SummaryStatisticsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.SummaryStatisticsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.GoveeEnergyMonitoringUIClient.prototype.getSummaryStatistics =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/GetSummaryStatistics',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_GetSummaryStatistics,
      callback);
};


/**
 * @param {!proto.proto.SummaryStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.SummaryStatisticsResponse>}
 *     Promise that resolves to the response
 */
proto.proto.GoveeEnergyMonitoringUIPromiseClient.prototype.getSummaryStatistics =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/GetSummaryStatistics',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_GetSummaryStatistics);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.AggregateStatisticsRequest,
 *   !proto.proto.SummaryStatisticsResponse>}
 */
const methodDescriptor_GoveeEnergyMonitoringUI_GetAggregateStatistics = new grpc.web.MethodDescriptor(
  '/proto.GoveeEnergyMonitoringUI/GetAggregateStatistics',
  grpc.web.MethodType.UNARY,
  proto.proto.AggregateStatisticsRequest,
  proto.proto.SummaryStatisticsResponse,
  /**
   * @param {!proto.proto.AggregateStatisticsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.SummaryStatisticsResponse.deserializeBinary
);


/**
 * @param {!proto.proto.AggregateStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.SummaryStatisticsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.SummaryStatisticsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.GoveeEnergyMonitoringUIClient.prototype.getAggregateStatistics =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/GetAggregateStatistics',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_GetAggregateStatistics,
      callback);
};


/**
 * @param {!proto.proto.AggregateStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.SummaryStatisticsResponse>}
 *     Promise that resolves to the response
 */
proto.proto.GoveeEnergyMonitoringUIPromiseClient.prototype.getAggregateStatistics =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/GetAggregateStatistics',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_GetAggregateStatistics);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DisplayNameRequest,
 *   !proto.proto.DisplayNameResponse>}
 */
const methodDescriptor_GoveeEnergyMonitoringUI_UpdateSmartPlugDisplayName = new grpc.web.MethodDescriptor(
  '/proto.GoveeEnergyMonitoringUI/UpdateSmartPlugDisplayName',
  grpc.web.MethodType.UNARY,
  proto.proto.DisplayNameRequest,
  proto.proto.DisplayNameResponse,
  /**
   * @param {!proto.proto.DisplayNameRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DisplayNameResponse.deserializeBinary
);


/**
 * @param {!proto.proto.DisplayNameRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DisplayNameResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DisplayNameResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.GoveeEnergyMonitoringUIClient.prototype.updateSmartPlugDisplayName =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/UpdateSmartPlugDisplayName',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_UpdateSmartPlugDisplayName,
      callback);
};


/**
 * @param {!proto.proto.DisplayNameRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DisplayNameResponse>}
 *     Promise that resolves to the response
 */
proto.proto.GoveeEnergyMonitoringUIPromiseClient.prototype.updateSmartPlugDisplayName =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.GoveeEnergyMonitoringUI/UpdateSmartPlugDisplayName',
      request,
      metadata || {},
      methodDescriptor_GoveeEnergyMonitoringUI_UpdateSmartPlugDisplayName);
};


module.exports = proto.proto;

